export interface InputTypeMap {
  mask: string;
  pattern: string;
  thousandSeparator?: string;
  maskErrorTooltip: string;
}

export const INPUT_TYPES_MAP: { INTEGER: InputTypeMap; DECIMAL: InputTypeMap; CURRENCY: InputTypeMap; DATE: InputTypeMap } = {
  INTEGER: {
    mask: '0*',
    pattern: '[0-9]*',
    maskErrorTooltip: 'MASK_ERROR.ONLY_DIGITS',
  },
  DECIMAL: {
    mask: '0*.000',
    pattern: '[-+]?[0-9]*[.]?[0-9]+',
    maskErrorTooltip: 'MASK_ERROR.ONLY_DIGITS',
  },
  CURRENCY: {
    mask: 'separator.2',
    pattern: '[0-9]*[.]?[0-9]+',
    thousandSeparator: ',',
    maskErrorTooltip: 'MASK_ERROR.ONLY_DIGITS',
  },
  DATE: {
    mask: 'd0/M0/0000',
    pattern: '[0-9][0-9]/[0-9][0-9]/[0-9][0-9][0-9][0-9]',
    maskErrorTooltip: 'MASK_ERROR.DATE',
  },
};
